<script>
  import { onDestroy } from 'svelte';

  import Tile from '@app-components/rec_request/Tile.svelte';
  import Modal from '@components/Modal.svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recRequestsStore = getGroupStore('recRequestsStore');

  let group = groupStore;
  let recRequests = recRequestsStore;
  let pendingRecRequests = [];

  let unsubGroup = group.subscribe((x) => (group = x));
  let unsubRecRequests = recRequestsStore.subscribe((x) => {
    recRequests = x;
    pendingRecRequests = recRequests.filter((x) => x.aasm_state == 'active' && !x.completed);
  });

  let showModal = false;

  var close = function () {
    showModal = false;
  };

  var show = function () {
    showModal = true;
  };

  onDestroy(() => {
    unsubGroup();
    unsubRecRequests();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 15px;
    text-align: center;
  }

  .rec-request-done {
    background: #2caf87 !important;

    .name-bar {
      color: white !important;
    }
  }

  .rec-request-container {
    width: 150px;
    height: 140px;
    margin-bottom: 15px;
  }
</style>

<Modal
  style="margin: 0px !important; border-radius: 0px !important; height: 100vh;
  max-height: unset !important;"
  mobile={true}
  show={showModal}
  on:close={close}
  showCloseButton={true}
  fadeInDuration={200}>
  <div slot="content">
    <div class="ui-header" style="margin-bottom: 30px; margin-top: -55px;">Rec Requests</div>

    <div
      style="margin-top: 50px; color: #1a1a1a; font-size: 13px; font-weight:
      500; margin-left: auto; margin-right: auto; padding-left: 30px; width:
      315px;">
      <div style="opacity: 0.5; line-height: 24px; font-size: 15px;">
        {group.name}
      </div>
      <div style="line-height: 24px;">Share your recommendations</div>
    </div>

    <div
      style="display: flex; flex-wrap: wrap; margin-top: 40px; width: 315px;
      margin-left: auto; margin-right: auto;">
      {#each recRequests as rr, i}
        <div class="rec-request-container" style={i % 2 != 0 ? 'margin-left: 15px;' : ''}>
          <Tile recRequest={rr} mobile={true} />
        </div>
      {/each}
    </div>
  </div>
</Modal>

<div
  style="display: flex; align-items: center; margin-top: 40px; margin-bottom:
  10px; cursor: pointer;">
  {#if pendingRecRequests.length == 0}
    <div
      on:click|preventDefault={show}
      style="height: 40px; display: flex; justify-content: center; align-items:
      center; font-weight: 500; font-size: 13px; background-color: #7ac0a7;
      border-radius: 12px;">
      <div style="flex: 1; color: white; padding-left: 20px; padding-right: 20px;">Rec Requests</div>
      <div style="padding-right: 20px;">
        <div
          style="color: #7ac0a7; width: 22px; height: 22px; display: flex;
          justify-content: center; align-items: center; background: white;
          border-radius: 8px;">
          <i class="fa fa-check" style="font-size: 10px;" />
        </div>
      </div>
    </div>
  {:else}
    <div
      on:click|preventDefault={show}
      style="height: 40px; display: flex; justify-content: center; align-items:
      center; font-weight: 500; font-size: 13px; background-color: #e9e5fd;
      border-radius: 12px;">
      <div style="flex: 1; padding-left: 20px; padding-right: 20px;">Rec Requests</div>
      <div style="padding-right: 20px;">
        <div
          style="width: 22px; height: 22px; display: flex; justify-content:
          center; align-items: center; background: white; border-radius: 8px;
          font-size: 14px; font-weight: 500;">
          {pendingRecRequests.length}
        </div>
      </div>
    </div>
  {/if}
</div>
